import { PageLayout } from 'core/components';

import { companySettingsPath, userProfilePath } from './routePaths';

export const userProfile = {
  path: userProfilePath(),
  exact: true,
  isPrivate: true,
  element: <PageLayout title="Profile"></PageLayout>,
};

export const companySettings = {
  path: companySettingsPath(),
  exact: true,
  isPrivate: true,
  element: <PageLayout title="Company Settings"></PageLayout>,
};
